import React, {useContext, useEffect} from "react";
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Button,
    Checkbox,
    FormControlLabel,
    TextField
} from "@mui/material";
import {useUserContext} from "../../contexts/user-context";
import WaitSpinner from "../../components/wait-spinner";
import {ToolbarContext} from "../../contexts/toolbar-context";
import {ClientCompanySelect} from "../../components/MaterialSelects/ClientCompanySelect";
import { SalesTeamSelect } from "../../components/MaterialSelects/SalesTeamSelect";



export function ContactForm({diaForm,waiting=false}) {
    //const params = useParams();
    const user = useUserContext();
    const toolbarContext = useContext(ToolbarContext);
    const baseUrl = '/contacts/';
    const readOnly  = !user.hasPermission('contacts.edit');
    const { values, onChange, status, isDirty, handleSubmit, errors } = diaForm;
    const id = values.id;
    const isNew = values.id=='new';
    const field = {
        onChange: onChange,
        readOnly: readOnly
    };
    useEffect(() => {
        const buttons = [{
            type: 'button',
            icon: 'save',
            tooltip: 'Save',
            callback: handleSubmit,
            label: 'Save',
            disabled: !isDirty
        }];
        toolbarContext.setSecondary(
            {
                primaryUrl:baseUrl,
                title: (!isNew ? values.name : 'New Contact'),
                secondary: buttons,
                secondaryUrl: id
            });
    }, [isDirty, id, status]);
    if(status=='loading') {
        return <WaitSpinner variant="panel"/>;
    }
    console.log('CFC',values);
    return (
        <Accordion defaultExpanded={true}>
            {waiting && <WaitSpinner variant="overlay"/>}
            <AccordionSummary>Contact</AccordionSummary>
            <AccordionDetails>
                <div className="grid12">
                    <TextField name="name" label="Name" value={values.name} {...field} />
                    <ClientCompanySelect  {...field} name="clientCompany" label="Company" value={values.clientCompany} />
                    <SalesTeamSelect {...field} name="salesTeam" label="Sales Team" value={values?.salesTeam?.name} error={!!errors?.salesTeam}/>
                    <TextField label="Title" name="title" value={values.title} {...field} />
                    <TextField label="Email" type="email" name="email" value={values.email} {...field} />
                    <TextField label="Phone" type="phone" name="phone" value={values.phone} {...field} />
                    <TextField label="Other Phone" type="phone" name="phone_alt" value={values.phone_alt} {...field} />
                    <TextField label="Comments" multiline={true} fullWidth={true} name="comments" value={values.comments} {...field} />
                    <TextField label="Job Sheet Info" multiline={true} fullWidth={true} name="job_sheet_info" value={values.job_sheet_info} {...field} />
                    {/* <FormControlLabel control={<Checkbox disabled={readOnly} name="is_marketing" checked={values.is_marketing} {...field} />} label="Is a marketing contact"/>
                    <FormControlLabel control={<Checkbox disabled={readOnly} name="is_sales" checked={values.is_sales} {...field} />} label="Is a sales contact"/> */}
                    <FormControlLabel control={<Checkbox disabled={readOnly} name="is_mailchimp" checked={values.is_mailchimp ?? true} {...field} />} label="Is a Mailchimp contact"/>

                </div>
            </AccordionDetails>
        </Accordion>
    );
}

